import mouse from './mouse'
import packetsPatcher from './packetsPatcher'
import webFeatures from './webFeatures'

// register
webFeatures()
packetsPatcher()


customEvents.on('mineflayerBotCreated', () => {
  bot.loadPlugin(mouse)
})
